var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.wrapperStyle)},[_c('b-form-group',{attrs:{"label-cols":_vm.labelCols,"label-align":"right","label":_vm.label}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }